/**
 * AgentBiddingPanel — bidding-agent tab of the Lead Agent Workspace.
 * Wraps BiddingAnalysisPanel (qualification, cost estimate, timber extraction,
 * proposal prep) and forwards "View on plan" clicks so timber rows can deep-link
 * into the document viewer at the agent's annotation.
 */

import React, { useCallback } from 'react';
import type { Lead, EnhancedDeal, BiddingTimberItem, BiddingTakeoffProposal } from '../../types';
import { BiddingAnalysisPanel } from './BiddingAnalysisPanel';
import { BiddingTakeoffProposalPanel } from './BiddingTakeoffProposalPanel';

interface AgentBiddingPanelProps {
  lead: Lead;
  deals: EnhancedDeal[];
  onViewOnPlan?: (item: BiddingTimberItem) => void;
}

export const AgentBiddingPanel: React.FC<AgentBiddingPanelProps> = ({ lead, deals, onViewOnPlan }) => {
  const handleViewProposalOnPlan = useCallback(
    (proposal: BiddingTakeoffProposal) => {
      if (!onViewOnPlan) return;
      onViewOnPlan({
        id: proposal.id || 'proposal',
        name: proposal.proposedLink?.name || 'Take-off item',
        quantity: proposal.proposedLink?.quantity ?? 1,
        width: 0,
        height: 0,
        length: '',
        documentId: proposal.documentId,
        pageNumber: proposal.pageNumber,
        annotationId: proposal.annotationId,
      });
    },
    [onViewOnPlan],
  );

  return (
    <>
      <BiddingAnalysisPanel lead={lead} deals={deals} onViewOnPlan={onViewOnPlan} />
      {lead.id && (
        <BiddingTakeoffProposalPanel
          leadId={lead.id}
          onViewOnPlan={onViewOnPlan ? handleViewProposalOnPlan : undefined}
        />
      )}
    </>
  );
};

export default AgentBiddingPanel;
